<template>
  <!-- 选择用户  -->
  <el-dialog title="选择用户" :visible.sync="visible" width="40%">
    <div class="h-select-user-dialog">
      <div class="screen-box">
        <!-- 部门选择器 -->
        <el-cascader class="screen-input" :props="deptProps" ref="deptSelect" v-model="currentDept" @change="handleDeptChange" placeholder="请选择部门" :clearable="true" :show-all-levels="false"></el-cascader>
        <el-input v-model="keywords" class="screen-input" placeholder="维修人员姓名" clearable></el-input>
        <!-- <el-button type="primary" @click="getUserList">搜索</el-button>
        <el-button @click="keywords=''">重置</el-button> -->
      </div>
      <div class="repair-worker-table">
        <el-table ref="hSelectUserTable" @row-click="rowClick" :data="userList.filter(data => !keywords || data.name.toLowerCase().includes(keywords.toLowerCase()))" tooltip-effect="dark" height="100%" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="100" align='center' v-if="type=='multiple'">
          </el-table-column>
          <el-table-column prop="" label="" width="100" align='center' v-if="type=='radio'">
            <template slot-scope="scope">
              <el-radio v-model="currentUser" :label="scope.row">{{""}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" align='center'>
          </el-table-column>
          <el-table-column prop="phone" label="电话" align='center' show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <div class="repair-worker-btn">
        <el-button size="mini" class="btn-style" type="primary" @click="submit" :disabled="submitBtnDisabled">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
let _this
export default {
  data () {
    return {
      visible: false,
      deptProps: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad: this.deptLazyLoad
      },
      userTreeProps: { label: 'name' },
      keywords: '',//筛选关键字
      deptlist: [],//部门列表
      currentDept: null,//筛选当前选中部门
      userList: [],//用户列表
      currentUser: null,//当前选中用户
      submitBtnDisabled: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'radio'//可选值 单选 radio 多选 multiple
    },
  },
  created () {
    _this = this
  },
  mounted () {
    this.getUserList()
  },
  watch: {
    visible (val) {
      if (val) {
        this.keywords = ''
        this.currentDept = null
        this.currentUser = null
      }
    },
    currentUser (val) {
      this.$emit('change', val)
    },
    currentDept (val) {
      console.log('currentDept', val);
      if (this.type == 'radio') {
        this.currentUser = null
      } else {
        this.$refs.hSelectUserTable.clearSelection();
      }


      this.getUserList()
    }
  },
  computed: {
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    },
    //懒加载部门级联选择器
    deptLazyLoad (node, resolve) {
      if (node.data) {
        var params = { superId: node.data.value }

        this.$API.getDepartmentList(params).then(
          res => {
            if (Array.isArray(res)) {
              const nodes = res.map(item => ({
                value: item.id,
                label: item.deptName
              }))
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes)
            }
          },
          err => {
            console.log('获取部门列表', err)
          }
        )
      } else {
        let deptId = this.$store.state.system.userInfo.departmentId
        if (!deptId) {
          return
        }
        let data = {};
        data.dept_id = deptId
        this.$API.getDepartmentDetail(data).then(
          res => {
            const nodes = [{
              value: res.id,
              label: res.deptName
            }]
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)

          },
          err => {
          }
        )
      }

    },
    // 部门选择器选中状态变化
    handleDeptChange (e) {
      this.currentDept = e
      this.$refs.deptSelect.dropDownVisible = false
    },
    //获取用户列表
    getUserList () {
      let data = {}
      if (this.currentDept) {
        data.deptId = this.currentDept
      }
      if (this.keywords) {
        data.emplpyeeNmae = this.keywords
      }
      this.$API.getEmployeeList(data).then(
        res => {
          this.userList = res
        },
        err => {

        }
      )
    },
    handleSelectionChange (e) {
      this.currentUser = e
    },
    rowClick (e) {
      if (this.type == 'radio') {
        this.currentUser = e
      } else {
        if (this.currentUser) {
          if (this.currentUser.indexOf(e) > -1) {
            this.currentUser.splice(this.currentUser.indexOf(e), 1);
            let list = this.currentUser
            this.$refs.hSelectUserTable.clearSelection();
            for (let i = 0; i < list.length; i++) {
              this.$refs.hSelectUserTable.toggleRowSelection(list[i]);
            }
          } else {
            this.currentUser.push(e)
            let list = this.currentUser
            this.$refs.hSelectUserTable.clearSelection();
            for (let i = 0; i < list.length; i++) {
              this.$refs.hSelectUserTable.toggleRowSelection(list[i]);
            }
          }
        } else {
          this.currentUser = []
          this.currentUser.push(e)
          this.$refs.hSelectUserTable.toggleRowSelection(e);
        }
      }
    },



    // 提交
    submit () {

      if (this.submitBtnDisabled) {
        return
      }
      this.submitBtnDisabled = true
      if (this.type == 'radio') {
        if (!this.currentUser) {
          this.$message({
            message: '未选中用户',
            duration: 1500,
            type: 'warning'
          })
          this.submitBtnDisabled = false
          return
        }
      } else {
        if (!this.currentUser || this.currentUser.length == 0) {
          this.$message({
            message: '未选中用户',
            duration: 1500,
            type: 'warning'
          })
          this.submitBtnDisabled = false
          return
        }
      }
      console.log('提交', this.currentUser);
      this.$emit('submit', this.currentUser)
      this.visible = false
    }
  },
}
</script>
<style scoped lang="stylus">
.h-select-user-dialog
  height 600px
  display flex
  flex-direction column
  .screen-box
    display flex
    flex-direction row
    height 60px
    align-items center
    .screen-input
      flex 1
      margin-right 20px
  .repair-worker-table
    height 480px
.repair-worker-btn
  height 60px
  display flex
  align-items flex-end
  justify-content center
.btn-style
  width 90px
  height 34px
  >>>.el-table-column--selection
    display none
</style>



// WEBPACK FOOTER //
// src/components/parts/HSelectUserDialog.vue